/**
 * 从url获取参数 返回json
 * - 没参数返回undefined
 * @param {\} url 
 */
export const getParamsByUrl = url => {
  if (url.indexOf('?') !== -1) {
    const params = url.substring(url.indexOf('?') + 1)
    if (params) {
      const paramList = params.split('&');
      let arr;
      const result = {};
      paramList.map(o => {
        if (o) {
          arr = o.split('=');
          result[arr[0]] = arr[1];
        }
      })
      console.log(paramList, result)
      return result;
    }
  }
  return undefined
}


// WEBPACK FOOTER //
// ./src/utils/strUtil.js